import {AbstractModel} from '../abstract-model';

export class Stat extends AbstractModel {
  clicks: number | null = 0;
  uniqueClicks: number | null = 0;
  conversions: number | null = 0;
  conversionRate: number | null = 0;
  revenue: number | null = 0;
  epc: number | null = 0;
}
